const QUEST_PACK_IMAGE_DIRECTORY = '/images/quest-packs';
const SAFE_QUEST_PACK_IMAGE_FILENAME = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

export function getQuestPackImageSrc(packImage) {
  if (typeof packImage !== 'string') {
    return null;
  }

  const trimmedValue = packImage.trim();
  if (!trimmedValue) {
    return null;
  }

  if (/^(https?:)?\/\//i.test(trimmedValue) || trimmedValue.startsWith('/')) {
    return trimmedValue;
  }

  if (!SAFE_QUEST_PACK_IMAGE_FILENAME.test(trimmedValue)) {
    return null;
  }

  return `${QUEST_PACK_IMAGE_DIRECTORY}/${trimmedValue}`;
}

export default getQuestPackImageSrc;
